import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { Badge } from "../../components/ui/badge";
import { Avatar, AvatarFallback } from "../../components/ui/avatar";
import { Search, Users, Mail, Phone, MapPin } from "lucide-react";
import { useState } from "react";
function Customers() {
  const [searchTerm, setSearchTerm] = useState("");

  const customers = [
    {
      id: 1,
      name: "John Doe",
      email: "john.doe@email.com",
      phone: "+1 (555) 123-4567",
      location: "New York, NY",
      totalClaims: 2,
      activePlans: 2,
      totalSpent: "$3,498.00",
      joinDate: "2024-01-15",
      status: "active",
      lastActivity: "2024-06-27",
    },
    {
      id: 2,
      name: "Sarah Wilson",
      email: "sarah.wilson@email.com",
      phone: "+1 (555) 234-5678",
      location: "Los Angeles, CA",
      totalClaims: 0,
      activePlans: 1,
      totalSpent: "$899.00",
      joinDate: "2024-03-20",
      status: "active",
      lastActivity: "2024-06-25",
    },
    {
      id: 3,
      name: "Michael Chen",
      email: "michael.chen@email.com",
      phone: "+1 (555) 345-6789",
      location: "Chicago, IL",
      totalClaims: 3,
      activePlans: 3,
      totalSpent: "$4,297.00",
      joinDate: "2023-11-10",
      status: "active",
      lastActivity: "2024-06-28",
    },
    {
      id: 4,
      name: "Emily Rodriguez",
      email: "emily.rodriguez@email.com",
      phone: "+1 (555) 456-7890",
      location: "Austin, TX",
      totalClaims: 1,
      activePlans: 0,
      totalSpent: "$1,299.00",
      joinDate: "2024-02-05",
      status: "inactive",
      lastActivity: "2024-05-15",
    },
  ];

  const filteredCustomers = customers.filter(
    (customer) =>
      customer.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      customer.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getStatusBadge = (status) => {
    return status === "active" ? (
      <Badge className="bg-success text-white">Active</Badge>
    ) : (
      <Badge className="bg-slate-400 text-white">Inactive</Badge>
    );
  };
  return (
    <>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 mb-2">
            Customer Management
          </h1>
          <p className="text-slate-600">
            Manage customer accounts and view protection plan history
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <Card>
            <CardContent className="!p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-slate-600">
                    Total Customers
                  </p>
                  <p className="text-3xl font-bold text-slate-900">1,247</p>
                </div>
                <div className="w-12 h-12 bg-comerco-primary bg-opacity-10 rounded-lg flex items-center justify-center">
                  <Users className="text-comerco-primary" size={24} />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="!p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-slate-600">
                    Active Plans
                  </p>
                  <p className="text-3xl font-bold text-slate-900">3,456</p>
                </div>
                <div className="w-12 h-12 bg-success bg-opacity-10 rounded-lg flex items-center justify-center">
                  <Badge className="bg-success text-white text-lg">AP</Badge>
                </div>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="!p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-slate-600">
                    New This Month
                  </p>
                  <p className="text-3xl font-bold text-slate-900">89</p>
                </div>
                <div className="w-12 h-12 bg-info bg-opacity-10 rounded-lg flex items-center justify-center">
                  <Users className="text-info" size={24} />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="!p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-slate-600">
                    Avg. Lifetime Value
                  </p>
                  <p className="text-3xl font-bold text-slate-900">$2,341</p>
                </div>
                <div className="w-12 h-12 bg-warning bg-opacity-10 rounded-lg flex items-center justify-center">
                  <span className="text-warning text-lg font-bold">$</span>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <Card>
          <CardContent className="!p-6">
            <div className="flex gap-4">
              <div className="flex-1 relative">
                <Search
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400"
                  size={16}
                />
                <Input
                  placeholder="Search customers by name or email..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10"
                />
              </div>
              <Button className="bg-comerco-primary hover:bg-blue-700">
                Export Data
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-0">
            <Table>
              <TableHeader>
                <TableRow className="bg-slate-50">
                  <TableHead>Customer</TableHead>
                  <TableHead>Contact</TableHead>
                  <TableHead>Location</TableHead>
                  <TableHead>Plans</TableHead>
                  <TableHead>Claims</TableHead>
                  <TableHead>Total Spent</TableHead>
                  <TableHead>Status</TableHead>
                  <TableHead>Last Activity</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filteredCustomers.map((customer) => (
                  <TableRow
                    key={customer.id}
                    className="hover:bg-slate-50 cursor-pointer"
                  >
                    <TableCell>
                      <div className="flex items-center gap-3">
                        <Avatar>
                          <AvatarFallback className="bg-comerco-primary text-white">
                            {customer.name
                              .split(" ")
                              .map((n) => n[0])
                              .join("")}
                          </AvatarFallback>
                        </Avatar>
                        <div>
                          <p className="font-medium text-slate-900">
                            {customer.name}
                          </p>
                          <p className="text-sm text-slate-500">
                            ID: {customer.id.toString().padStart(6, "0")}
                          </p>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="space-y-1">
                        <div className="flex items-center gap-2">
                          <Mail size={14} className="text-slate-400" />
                          <span className="text-sm">{customer.email}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Phone size={14} className="text-slate-400" />
                          <span className="text-sm">{customer.phone}</span>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="flex items-center gap-2">
                        <MapPin size={14} className="text-slate-400" />
                        <span className="text-sm">{customer.location}</span>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="text-center">
                        <p className="text-lg font-semibold text-slate-900">
                          {customer.activePlans}
                        </p>
                        <p className="text-xs text-slate-500">active</p>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="text-center">
                        <p className="text-lg font-semibold text-slate-900">
                          {customer.totalClaims}
                        </p>
                        <p className="text-xs text-slate-500">total</p>
                      </div>
                    </TableCell>
                    <TableCell>
                      <span className="font-semibold text-slate-900">
                        {customer.totalSpent}
                      </span>
                    </TableCell>
                    <TableCell>{getStatusBadge(customer.status)}</TableCell>
                    <TableCell>
                      <span className="text-sm text-slate-500">
                        {new Date(customer.lastActivity).toLocaleDateString()}
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
export default Customers;
